// extracted by mini-css-extract-plugin
module.exports = {"sub-menu-item":"sub-menu-item_12D-nq","subMenuItem":"sub-menu-item_12D-nq","txt":"txt_3ycVal","active":"active_1htZsN"};